import { initializeApp } from "firebase/app";
import { getAuth, GoogleAuthProvider, signInWithPopup, signOut, signInWithRedirect, getRedirectResult } from "firebase/auth";
import { getFirestore } from "firebase/firestore";

const firebaseConfig = {
  apiKey: "AIzaSyB4qT-G0VWhugbaq2sNk9cr4ytNEf2ROJU",
  authDomain: "newsnine-c6063.firebaseapp.com",
  projectId: "newsnine-c6063",
  storageBucket: "newsnine-c6063.appspot.com",
  messagingSenderId: "256195791765",
  appId: "1:256195791765:web:2a52e559107aff75a3449c",
  measurementId: "G-R6N4KNNWYH"
};

const app = initializeApp(firebaseConfig);
const auth = getAuth(app);
const db = getFirestore(app);

export const signInWithGoogle = async () => {
  const provider = new GoogleAuthProvider();
  try {
    const result = await signInWithPopup(auth, provider);
    const user = result.user;
    console.log('User signed in:', user);
    return user;
  } catch (error) {
    console.error('Error during Google sign-in:', error);
    throw error;
  }
};

export const signInWithAuthorizationCode = async () => {
  const provider = new GoogleAuthProvider();
  try {
    await signInWithRedirect(auth, provider);
  } catch (error) {
    console.error('Error during authorization code sign-in:', error);
    throw error;
  }
};

export const getAuthResult = async () => {
  try {
    const result = await getRedirectResult(auth);
    if (result) {
      const user = result.user;
      console.log('User signed in with authorization code:', user);
      return user;
    }
  } catch (error) {
    console.error('Error getting authorization code result:', error);
    throw error;
  }
};

export const logout = async () => {
  try {
    await signOut(auth);
    console.log('User signed out');
  } catch (error) {
    console.error('Error signing out:', error);
  }
};

export { auth, db };